import { render, staticRenderFns } from "./settingOne.vue?vue&type=template&id=7001a1e9&"
import script from "./settingOne.vue?vue&type=script&lang=js&"
export * from "./settingOne.vue?vue&type=script&lang=js&"
import style0 from "./setting.less?vue&type=style&index=0&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports